import React, { Component } from 'react';
import Head from 'next/head'
import { SeasonDivisionSelector, Header, Footer, Fixture, DivisionPageWrapper } from '../components'
import { fetchDivisions } from '../api/divisions'
import { fetchFutureFixtures } from '../api/fixtures'
import { format } from 'date-fns'

class FixturesPage extends Component {
  static async getInitialProps({req, query, props}) {
    let params = {'division_id': props.divisionId}
    if (props.competitionId == 'all') {
      params = {'season_id': props.seasonId}
    } else if (props.divisionId == 'all') {
      params = {'competition_id': props.competitionId}
    }

    if (props.organisationId != 48) {
      params.organisation_id = props.organisationId;
    }
    
    const fixtures = await fetchFutureFixtures(params)
    const allDivisionsPromise = fetchDivisions(props.organisationId)

    return {
      fixtures:  fixtures.data,
      allDivisions: await allDivisionsPromise,
      organisationId: props.organisationId
    }
  }

  render() {
    const { divisionId, fixtures,  seasonId, competitionId, seasons, competitions, divisions, allDivisions, organisationId, organisation, pages } = this.props
    const showOrganisation = organisation.id == 48
    let currentDate, lastDate
    return (
      <div className={`u-grid u-grid--basic u-grid-${organisationId}`}>
        <Head>
          <title>{`${organisation.name} | Fixtures`}</title>
        </Head>
        <Header region={organisation.name} regionId={organisation.id} pages={pages}/>
        <div className="u-grid__main">
          <h1>{'Fixtures'}</h1>
          <SeasonDivisionSelector
            baseUrl={`fixtures`}
            seasons={seasons}
            competitions={competitions}
            divisions={divisions}
            divisionId={divisionId}
            seasonId={seasonId}
            competitionId={competitionId}/>

          {fixtures.map(fixture =>
            <div key={fixture.id}>
              {currentDate = format(fixture.start_time, 'Do MMMM YYYY'), ''}
              {currentDate != lastDate && <h2 className="u-aux">{format(fixture.start_time, 'Do MMMM YYYY')}</h2>}
              <Fixture type="full" fixture={fixture} divisions={allDivisions} fixtures={fixtures} showOrganisation={showOrganisation}/>
              {lastDate = currentDate, ''}
            </div>
          )}
          {fixtures.length == 0 && <p>No Fixtures to display</p>}
        </div>
        <Footer regionId={organisation.id}/>
      </div>
    )
  }

}

export default DivisionPageWrapper(FixturesPage)
